import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./context/UserContext";
import { Toaster } from 'react-hot-toast';

ReactDOM.createRoot(document.getElementById("root")).render(
  <UserProvider>
    <BrowserRouter basename="/dashboard">
        <App />
        <Toaster />
    </BrowserRouter>
  </UserProvider>
);
